/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';
import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { ERRORS } from '@/constants/error';
import { Dictionary } from '@/i18n/i18n.setup';
import { tFormat } from '@/utils/t-format';

type AppContext =
  | {
      t?: Dictionary;
      context?: any;
    }
  | undefined;

const AppCtx = createContext<AppContext>(undefined);

export const useTranslation = () => {
  const context = useContext(AppCtx);
  if (!context) {
    throw ERRORS.REGULAR('`useTranslation` hook should be used within Page or AppProvider');
  }
  return { t: context.t, tFormat };
};
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const useAppContext = <T = any>() => {
  const context = useContext(AppCtx);
  if (!context) {
    throw ERRORS.REGULAR('`useAppContext` hook should be used within Page or AppProvider');
  }
  return context.context as T;
};

export type AppProviderProps = PropsWithChildren<{
  t: Dictionary | undefined;
  context: any;
}>;

const AppProvider: FC<AppProviderProps> = ({ t, context, children }) => {
  return <AppCtx.Provider value={{ t, context }}>{children}</AppCtx.Provider>;
};

export default AppProvider;
